import { useSelector } from "react-redux";
import React, { useState } from "react";

import { selectCalendarInitialDate, selectCalendarView } from "@hubcapp/state";
import { useTealium } from "@hubcapp/context";

import { DeleteTimeOffConfirmationModalStateProviderProps } from "./types";
import { getCalenderEventsQueryInput } from "../../../helpers";
import DeleteTimeOffConfirmationModal from "./DeleteTimeOffConfirmationModal";
import useMutationDeleteUnavailableEvent from "./hooks/useMutationCancelTimeOff";

const StateProvider: React.FC<DeleteTimeOffConfirmationModalStateProviderProps> = ({
  eventId,
  onCancel = () => {},
  onSubmit = () => {},
  repeat,
}) => {
  const view = useSelector(selectCalendarView);
  const [submitting, setSubmitting] = useState<boolean>(false);
  const initialDate =
    useSelector(selectCalendarInitialDate) || new Date(Date.now());
  const { trackEvent } = useTealium();

  const [deleteEvent, { loading }] = useMutationDeleteUnavailableEvent({
    onCompleted: () => {
      setSubmitting(false);
      onSubmit();
    },
  });

  const handleClick = (option: string) => {
    trackEvent({
      eventCategory: "Calendar - Time Off",
      eventAction: "Button Click",
      eventLabel: `${option == "ONE" ? "Just This One" : "All Events"}`,
    });
    setSubmitting(true);
    deleteEvent({
      variables: {
        id: eventId,
        cancelSeries: option === "ALL",
        reason: "",
        ...getCalenderEventsQueryInput(initialDate, view),
      },
    });
  };

  const handleCancelClick = () => {
    trackEvent({
      eventCategory: "Calendar - Time Off",
      eventAction: "Button Click",
      eventLabel: "Cancel",
    });
    onCancel();
  };

  return (
    <DeleteTimeOffConfirmationModal
      onCancel={handleCancelClick}
      onClick={handleClick}
      repeat={repeat}
      loading={loading}
      submitting={submitting}
    />
  );
};

export default StateProvider;
